import React from 'react';
import './index.css';
import { StatusBadgeProps } from '../../redux/AllocationRequest';

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const getStatusClass = () => {
    switch(status) {
      case 'Approved': return 'status-badge-approved';
      case 'Rejected': return 'status-badge-rejected';
      default: return 'status-badge-pending';
    }
  };

  return (
    <span className={`status-badge ${getStatusClass()}`}>
      {status}
    </span>
  );
};